import { IconProps } from '@phosphor-icons/react';

export const CorridorsIcon = ({ size = 16, height, color = 'currentColor', ...rest }: IconProps) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path d="M1.66797 13H14.3346" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.66797 8H3.66797" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 8H9" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.332 8H14.332" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.66797 3H14.3346" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
